import { render, staticRenderFns } from "./add_ticket.vue?vue&type=template&id=ec9f0a60&scoped=true"
import script from "./add_ticket.vue?vue&type=script&lang=js"
export * from "./add_ticket.vue?vue&type=script&lang=js"
import style0 from "./add_ticket.vue?vue&type=style&index=0&id=ec9f0a60&prod&lang=css"
import style1 from "./add_ticket.vue?vue&type=style&index=1&id=ec9f0a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9f0a60",
  null
  
)

export default component.exports